import React, { useRef, useState, useEffect } from "react";
import { getDateTime, isRoleHisReadOnly } from "app/common/LocalFunction";
import { APPOINTMENT_STAGES } from "app/common/LocalConst";
import { IconButton, Tooltip } from "@material-ui/core";
import IconPen from "app/common/Icon/IconPen";
import { useStore } from "app/stores";

const FlowSeriesTimeline = ({ items }) => {
  const { handleOpenFormCreateOrEdit } =
    useStore().patientManagementStore.checkInListStore;

  const isReadonly = isRoleHisReadOnly();
  return (
    <div
      className="timeline-group mt-2"
      style={{ width: "100%", overflow: "auto" }}
    >
      <ol class="timeline">
        {items?.map((item, index) => {
          return (
            <li class="timeline-item">
              <div className="timeline-item-group flex align-center justify-between">
                <div>
                  <span
                    style={{
                      fontSize: "var(--fs-base)",
                      fontWeight: "600",
                      color: "#000",
                    }}
                  >
                    {getDateTime(item?.encounterDatetime)}{" "}
                  </span>
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "var(--fs-base)",
                      color: "#2563eb",
                    }}
                  >
                    {item?.currentVisitDepName}
                  </span>
                  {item?.practitioner && (
                    <div style={{ fontWeight: "bold", fontSize:  "var(--fs-base-two)", }}>
                      <tspan style={{ fontStyle: "italic",  fontSize:  "var(--fs-base-two)", }}>
                        Người check in:{" "}
                      </tspan>

                      <tspan
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize:  "var(--fs-base-two)",
                        }}
                      >
                        {item?.practitioner?.staffName}
                      </tspan>
                      <tspan
                        style={{
                          color: "green",
                          fontWeight: "bold",
                          fontSize:  "var(--fs-base-two)",
                          marginLeft: "4px",
                        }}
                      >
                        {item?.typeOfVisit?.name}
                      </tspan>
                    </div>
                  )}
                  {item?.visitStopDateTime && (
                    <div style={{ fontWeight: "bold", fontSize: "var(--fs-base)" }}>
                      <tspan style={{ fontStyle: "italic", fontSize:  "var(--fs-base-two)", }}>
                        Thời gian checkout:{" "}
                      </tspan>

                      <tspan
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize:  "var(--fs-base-two)",
                        }}
                      >
                        {getDateTime(item?.visitStopDateTime)}
                      </tspan>
                    </div>
                  )}

                  {item?.currentTelesale && (
                    <div style={{ fontWeight: "bold", fontSize:  "var(--fs-base-two)", }}>
                      <tspan style={{ fontStyle: "italic",  fontSize:  "var(--fs-base-two)", }}>
                        Sale:{" "}
                      </tspan>

                      <tspan
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize:  "var(--fs-base-two)",
                        }}
                      >
                        {item?.currentTelesale?.staffName}
                      </tspan>
                    </div>
                  )}

                  {item?.companion && (
                    <div style={{ fontWeight: "bold", fontSize: "var(--fs-base-two)", lineHeight: 1.4, marginTop: "4px" }}>
                      <tspan style={{ fontStyle: "italic", fontSize: "var(--fs-base-two)" }}>
                        Người đi cùng:{" "}
                      </tspan>

                      <tspan
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "var(--fs-base-two)",
                        }}
                      >
                        {item?.companion?.displayName}
                      </tspan>
                      <tspan
                        style={{
                          color: "#4276a4",
                          fontWeight: "bold",
                          fontSize: "var(--fs-base-two)",
                          marginLeft: "4px",
                        }}
                      >
                        {item?.companion?.code}
                      </tspan>
                    </div>
                  )}

                  {(item?.customerSource?.name || item?.customerSourceDetail?.name) && (
                    <div style={{ fontSize: "var(--fs-base-two)", lineHeight: 1.4, marginTop: "4px" }}>
                      <span style={{ fontStyle: "italic", color: "#555" }}>Nguồn checkin:</span>
                      <span style={{ fontWeight: "bold", color: "#16a34a", marginRight: "8px" }}>
                        {item?.customerSource?.name}
                      </span>
                      {item?.customerSourceDetail?.name && (
                        <>
                          <span style={{ fontStyle: "italic", color: "#555" }}>Chi tiết nguồn:</span>
                          <span style={{ fontWeight: "bold", color: "#16a34a" }}>
                            {item?.customerSourceDetail?.name}
                          </span>
                        </>
                      )}
                    </div>
                  )}

                </div>
                <div className="pl-2 pr-2 flex align-center">
                  {!isReadonly && (
                    <Tooltip title="Chỉnh sửa">
                      <IconButton
                        size="small"
                        style={{ color: "#eb7d15" }}
                        onClick={() => {
                          handleOpenFormCreateOrEdit(item);
                        }}
                      >
                        <IconPen />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default FlowSeriesTimeline;
